<template>
    <div class="increment">
        <b-button
                variant="outline-secondary"
                class="action-button"
                @click="decrement()"
        >
            <i
                    class="fal fa-minus"
            />
        </b-button>
        <input
                v-if="renderInput"
                class="increment-input"
                type="number"
                :disabled="inputDisabled"
                :value="internalModel"
                :placeholder="placeholder"
                @input="handleIncrementInput($event.target.value)"
        >
        <b-button
                variant="outline-secondary"
                class="action-button"
                @click="increment()"
        >
            <i
                    class="fal fa-plus"
            />
        </b-button>
    </div>
</template>

<script>
    import './Increment.scss';
    import VModel from "../../mixins/VModel";
    import toNumber from 'lodash/toNumber';
    import debounce from 'lodash/debounce';

    export default {
        name: 'Increment',
        mixins: [
            VModel
        ],
        props: {
            value: {
                type: [Number, String],
                default: null,
                validator(value) {
                    if (value === null || Number.isNaN(value) || toNumber(value) === 0) {
                        return true;
                    }
                    return Boolean(toNumber(value));
                }
            },
            inputDisabled: {
                type: Boolean,
                default: false,
            },
            min: {
                type: [Number, String],
                default: null,
                validator(value) {
                    if (value === null || Number.isNaN(value) || toNumber(value) === 0) {
                        return true;
                    }
                    return Boolean(toNumber(value));
                }
            },
            max: {
                type: [Number, String],
                default: null,
                validator(value) {
                    if (value === null || Number.isNaN(value) || toNumber(value) === 0) {
                        return true;
                    }
                    return Boolean(toNumber(value));
                }
            },
            step: {
                type: [Number, String],
                default: 1,
                validator(value) {
                    return Boolean(toNumber(value));
                }
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                internalModel: this.value ? toNumber(this.value) : null,
                renderInput: true,
            };
        },
        computed: {},
        methods: {
            increment() {
                if (this.max === null) {
                    this.internalModel = this.internalModel + toNumber(this.step);
                    return;
                }

                if (this.internalModel === toNumber(this.max)) {
                    return;
                }
                const nextValue = this.internalModel + toNumber(this.step);

                if (nextValue <= toNumber(this.max)) {
                    this.internalModel = nextValue;
                }

                if (nextValue >= toNumber(this.max)) {
                    this.internalModel = toNumber(this.max);
                }
            },
            decrement(value) {
                if (this.min === null) {
                    this.internalModel = this.internalModel - toNumber(this.step);
                    return;
                }
                if (this.internalModel === toNumber(this.min)) {
                    return;
                }

                const nextValue = this.internalModel - toNumber(this.step);
                if (nextValue >= toNumber(this.min)) {
                    this.internalModel = nextValue;
                }

                if (nextValue <= toNumber(this.min)) {
                    this.internalModel = toNumber(this.min);
                }
            },
            handleIncrementInput(value) {
                if (this.max === null && this.min === null) {
                    this.internalModel = toNumber(value);
                }

                if (Boolean(this.max) && value > toNumber(this.max)) {
                    this.renderInput = false;
                    this.$nextTick(() => {
                        this.renderInput = true;
                    });
                    return;
                }
                if (Boolean(this.min) && value < toNumber(this.min)) {
                    this.renderInput = false;
                    this.$nextTick(() => {
                        this.renderInput = true;
                    });
                    return;
                }

                this.internalModel = toNumber(value);
            },
        },
        mounted() {
            this.handleIncrementInput = debounce(this.handleIncrementInput, 1000);
        }
    };
</script>
